function mountHeaderThemeBlockMenus(scope = document) {
  const templates = Array.from(scope.querySelectorAll('template[data-sa-header-desktop-menu]'));
  const touchedSections = new Set();

  templates.forEach((desktopTemplate) => {
    const handle = desktopTemplate.dataset.saHeaderDesktopMenu;
    const section = desktopTemplate.closest('.shopify-section') || scope;
    const escapedHandle = CSS.escape(handle);
    const desktopSlot = section.querySelector(`.header__inline-menu [data-sa-menu-slot="${escapedHandle}"]`);
    const mobileDrawer = section.querySelector('sa-mobile-menu-drawer');
    const mobileRootTemplate = section.querySelector(`template[data-sa-header-mobile-root="${escapedHandle}"]`);
    const mobilePanelTemplate = section.querySelector(`template[data-sa-header-mobile-panel="${escapedHandle}"]`);

    if (desktopSlot && desktopTemplate.content.firstElementChild) {
      desktopSlot.replaceWith(desktopTemplate.content.firstElementChild.cloneNode(true));
    }

    if (mobileDrawer && mobileRootTemplate?.content.firstElementChild) {
      const currentRootTrigger = mobileDrawer.querySelector(`#SaMobileMenu-${escapedHandle}`);
      const currentRootItem = currentRootTrigger?.closest('li');
      if (currentRootItem) {
        currentRootItem.replaceWith(mobileRootTemplate.content.firstElementChild.cloneNode(true));
      }
    }

    if (mobileDrawer && mobilePanelTemplate?.content.firstElementChild) {
      const viewport = mobileDrawer.querySelector('[data-sa-menu-viewport]');
      const currentPanel = mobileDrawer.querySelector(`[data-sa-menu-panel="${escapedHandle}"]`);
      const nextPanel = mobilePanelTemplate.content.firstElementChild.cloneNode(true);

      if (currentPanel) {
        currentPanel.replaceWith(nextPanel);
      } else if (viewport) {
        viewport.appendChild(nextPanel);
      }
    }

    touchedSections.add(section);
    desktopTemplate.remove();
    mobileRootTemplate?.remove();
    mobilePanelTemplate?.remove();
  });

  scope.querySelectorAll('template[data-sa-grid-item]').forEach((itemTemplate) => {
    const handle = itemTemplate.dataset.saGridItem;
    const section = itemTemplate.closest('.shopify-section') || scope;
    const escapedHandle = CSS.escape(handle);
    const desktopTarget = section.querySelector(`[data-sa-grid-items="${escapedHandle}"]`);
    const mobileTarget = section.querySelector(`[data-sa-mobile-grid-items="${escapedHandle}"]`);
    const mobileTemplate = section.querySelector(`template[data-sa-mobile-grid-item="${escapedHandle}"]`);

    if (desktopTarget && itemTemplate.content.firstElementChild) {
      desktopTarget.appendChild(itemTemplate.content.firstElementChild.cloneNode(true));
    }
    if (mobileTarget && mobileTemplate?.content.firstElementChild) {
      mobileTarget.appendChild(mobileTemplate.content.firstElementChild.cloneNode(true));
    }

    touchedSections.add(section);
    itemTemplate.remove();
    mobileTemplate?.remove();
  });

  scope.querySelectorAll('template[data-sa-banner-item]').forEach((itemTemplate) => {
    const handle = itemTemplate.dataset.saBannerItem;
    const section = itemTemplate.closest('.shopify-section') || scope;
    const escapedHandle = CSS.escape(handle);
    const desktopTarget = section.querySelector(`[data-sa-banner-items="${escapedHandle}"]`);
    const mobileTarget = section.querySelector(`[data-sa-mobile-banner-items="${escapedHandle}"]`);
    const mobileTemplate = section.querySelector(`template[data-sa-mobile-banner-item="${escapedHandle}"]`);

    if (desktopTarget && desktopTarget.children.length < 3 && itemTemplate.content.firstElementChild) {
      desktopTarget.appendChild(itemTemplate.content.firstElementChild.cloneNode(true));
    }
    if (mobileTarget && mobileTarget.children.length < 3 && mobileTemplate?.content.firstElementChild) {
      mobileTarget.appendChild(mobileTemplate.content.firstElementChild.cloneNode(true));
    }

    touchedSections.add(section);
    itemTemplate.remove();
    mobileTemplate?.remove();
  });

  scope.querySelectorAll('template[data-sa-super-panel]').forEach((panelTemplate) => {
    const handle = panelTemplate.dataset.saSuperPanel;
    const panelId = panelTemplate.dataset.saSuperPanelId;
    const section = panelTemplate.closest('.shopify-section') || scope;
    const escapedHandle = CSS.escape(handle);
    const escapedPanelId = CSS.escape(panelId);
    const panelTarget = section.querySelector(`[data-sa-super-panels="${escapedHandle}"]`);
    const superMenu = panelTarget?.closest('[data-super-mega-menu]');
    const entry = superMenu?.querySelector(`[data-sa-super-entry="${escapedPanelId}"]`);
    const mobileTemplate = section.querySelector(
      `template[data-sa-mobile-super-panel="${escapedHandle}"][data-sa-mobile-super-panel-id="${escapedPanelId}"]`,
    );
    const mobileEntry = section.querySelector(`[data-sa-mobile-super-entry="${escapedPanelId}"]`);

    let nextPanel = null;
    if (panelTarget && panelTemplate.content.firstElementChild) {
      const existingPanel = panelTarget.querySelector(`[data-panel-id="${escapedPanelId}"]`);
      nextPanel = panelTemplate.content.firstElementChild.cloneNode(true);

      if (existingPanel) {
        existingPanel.replaceWith(nextPanel);
      } else {
        panelTarget.appendChild(nextPanel);
      }
    }

    if (entry) {
      let trigger = entry;
      const viewMoreHref = (nextPanel?.dataset.viewMoreLink || '').trim();
      const isLevel3 = entry.matches(
        'a.super-mega-menu__l3-link, button.super-mega-menu__l3-item, a.super-mega-menu__l3-item',
      );

      if (isLevel3) {
        const href = viewMoreHref || (entry.getAttribute('href') || '').trim();
        trigger = document.createElement(href ? 'a' : 'button');
        if (!href) trigger.type = 'button';
        trigger.className = 'super-mega-menu__l3-item focus-inset';
        trigger.textContent = entry.textContent.trim();
        if (href) trigger.setAttribute('href', href);
        entry.replaceWith(trigger);
      } else if (
        entry.matches('a.super-mega-menu__l2-link') ||
        entry.matches('button.super-mega-menu__l2-trigger--panel')
      ) {
        const href = viewMoreHref || (entry.getAttribute('href') || '').trim();
        trigger = document.createElement(href ? 'a' : 'button');
        if (!href) trigger.type = 'button';
        trigger.className = 'super-mega-menu__l2-trigger super-mega-menu__l2-trigger--panel focus-inset';
        const label = document.createElement('span');
        label.textContent = entry.textContent.trim();
        trigger.appendChild(label);
        if (href) trigger.setAttribute('href', href);
        entry.closest('.super-mega-menu__l2-item')?.classList.add('super-mega-menu__l2-item--has-panel');
        entry.replaceWith(trigger);
      }

      trigger.dataset.panelId = panelId;
      trigger.dataset.saSuperEntry = panelId;
      trigger.setAttribute('aria-current', 'false');
    }

    if (mobileEntry && mobileTemplate?.content.firstElementChild) {
      const mobileAccordion = mobileTemplate.content.firstElementChild.cloneNode(true);
      mobileEntry.replaceWith(mobileAccordion);
    }

    touchedSections.add(section);
    panelTemplate.remove();
    mobileTemplate?.remove();
  });

  touchedSections.forEach((section) => {
    section.querySelectorAll('[data-super-mega-menu]').forEach((superMenu) => {
      const firstTrigger = superMenu.querySelector(
        '.super-mega-menu__l3-item[data-panel-id], .super-mega-menu__l2-trigger--panel[data-panel-id]',
      );
      const firstPanel = firstTrigger
        ? superMenu.querySelector(`[data-panel-id="${CSS.escape(firstTrigger.dataset.panelId)}"].super-mega-menu__panel`)
        : null;

      if (firstTrigger && firstPanel) {
        firstTrigger.classList.add('is-active');
        firstTrigger.setAttribute('aria-current', 'true');
        firstPanel.classList.add('is-active');
        firstPanel.hidden = false;
      }

      superMenu.superMegaMenuController?.bindLevel3Hover();
    });
  });

  touchedSections.forEach((section) => {
    section.querySelectorAll('[data-sa-banner-items]').forEach((target) => {
      target.classList.remove(
        'banner-mega-menu__grid--count-1',
        'banner-mega-menu__grid--count-2',
        'banner-mega-menu__grid--count-3',
      );
      target.classList.add(`banner-mega-menu__grid--count-${Math.max(1, target.children.length)}`);
    });
  });

  touchedSections.forEach((section) => {
    const mobileDrawer = section.querySelector('sa-mobile-menu-drawer');
    if (mobileDrawer?.viewport) {
      mobileDrawer.panels = Array.from(mobileDrawer.querySelectorAll('[data-sa-menu-panel]'));
      mobileDrawer.bindAccordions?.();
      mobileDrawer.resetPanels();
    }
  });

  if (typeof initSuperMegaMenus === 'function') {
    initSuperMegaMenus();
  }
}

mountHeaderThemeBlockMenus();

document.addEventListener('shopify:section:load', (event) => {
  mountHeaderThemeBlockMenus(event.target);
});
